<template>
  <div>
    <div class="m-b-10 f-s-10 m-t-10">
      <b class="text-inverse ts-uppercase">{{ $t('homePage.myRequest') }}</b>
    </div>
    <div class="ts-h-32 overflow-auto">
      <div class="widget-list widget-list-rounded m-b-10">
        <a
          @click.prevent="homework(0)"
          class="widget-list-item ts-whitespace-no-wrap"
        >
          <div class="widget-list-media icon">
            <i class="fas fa-book bg-info text-white"></i>
          </div>
          <div class="widget-list-content">
            <h4 class="widget-list-title">
              {{ $t('homePage.homeworkPending') }}
            </h4>
          </div>
          <div class="widget-list-action text-right">
            <span class="badge badge-info m-r-2">{{ homeworkPending }}</span>
            <i class="fa fa-angle-right fa-lg text-muted"></i>
          </div>
        </a>
        <a
          @click.prevent="homework(1)"
          class="widget-list-item ts-whitespace-no-wrap"
        >
          <div class="widget-list-media icon">
            <i class="fas fa-book-reader bg-primary text-white"></i>
          </div>
          <div class="widget-list-content">
            <h4 class="widget-list-title">
              {{ $t('homePage.partiallyApproved') }}
            </h4>
          </div>
          <div class="widget-list-action text-right">
            <span class="badge badge-primary m-r-2">
              {{ partiallyApproved }}
            </span>
            <i class="fa fa-angle-right fa-lg text-muted"></i>
          </div>
        </a>
        <a
          @click.prevent="homework(2)"
          class="widget-list-item ts-whitespace-no-wrap"
        >
          <div class="widget-list-media icon">
            <i class="fas fa-book-open bg-success text-white"></i>
          </div>
          <div class="widget-list-content">
            <h4 class="widget-list-title">
              {{ $t('homePage.homeworkApproved') }}
            </h4>
          </div>
          <div class="widget-list-action text-right">
            <span class="badge badge-success m-r-2">
              {{ homeworkApproved }}
            </span>
            <i class="fa fa-angle-right fa-lg text-muted"></i>
          </div>
        </a>
        <a
          @click.prevent="homework(3)"
          class="widget-list-item ts-whitespace-no-wrap"
        >
          <div class="widget-list-media icon">
            <i class="fas fa-file-prescription bg-danger text-white"></i>
          </div>
          <div class="widget-list-content">
            <h4 class="widget-list-title">
              {{ $t('homePage.homeworkRejected') }}
            </h4>
          </div>
          <div class="widget-list-action text-right">
            <span class="badge badge-danger m-r-2">{{ homeworkRejected }}</span>
            <i class="fa fa-angle-right fa-lg text-muted"></i>
          </div>
        </a>
      </div>
    </div>
    <ts-card class="m-t-10">
      <ts-card-wrapper>
        <div class="ts-flex">
          <div class="ts-flex-grow"></div>
          <div class="ts-flex justify-content-end">
            <select class="form-control mr-2" v-model="app_type_id">
              <option
                v-for="(app_type, index) in approveTypes"
                :key="index"
                :value="app_type.app_type_id"
                >{{ app_type.app_type }}</option
              >
            </select>
            <select class="form-control" v-model="approve_status">
              <option value>{{ $t('home.All') }}</option>
              <option :value="0">{{ $t('home.pending') }}</option>
              <option :value="1">{{ $t('home.partiallyApproved') }}</option>
              <option :value="2">{{ $t('home.approved') }}</option>
              <option :value="3">{{ $t('home.rejected') }}</option>
            </select>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">{{ record.request_id }}</td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ record.request_date }}
            </td>
            <td class="ts-whitespace-no-wrap">{{ record.class_name }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.subject_name }}</td>
            <td class="ts-whitespace-no-wrap text-center">
              <span
                class="badge badge-info"
                v-if="record.request_status == 'Pending'"
                >{{ $t('home.pending') }}</span
              >
              <span
                class="badge badge-primary"
                v-if="record.request_status == 'Partialy Approved'"
                >{{ $t('home.partiallyApproved') }}</span
              >
              <span
                class="badge badge-success"
                v-if="record.request_status == 'Approved'"
                >{{ $t('home.approved') }}</span
              >
              <span
                class="badge badge-danger"
                v-if="record.request_status == 'Rejected'"
                >{{ $t('home.rejected') }}</span
              >
            </td>
          </template>
        </ts-table>
      </div>
      <ts-card-wrapper class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  name: 'myRequest',
  data() {
    return {
      homeworkPending: 0,
      partiallyApproved: 0,
      homeworkApproved: 0,
      homeworkRejected: 0,
      loading: false
    }
  },
  created() {
    this.fetchTotal()
    this.fetchResource()
  },
  computed: {
    ...mapState('home/staffMyRequest', [
      'resources',
      'pagination',
      'approveTypes'
    ]),
    search: {
      get() {
        return this.$store.state.home.staffMyRequest.search
      },
      set(newVal) {
        this.$store.commit('home/staffMyRequest/SET_SEARCH', newVal)
        this.$store.commit('home/staffMyRequest/RESET_CURRENT_PAGE')
      }
    },
    app_type_id: {
      get() {
        return this.$store.state.home.staffMyRequest.app_type_id
      },
      set(val) {
        this.$store.commit('home/staffMyRequest/SET_APP_TYPE_ID', val)
      }
    },
    approve_status: {
      get() {
        return this.$store.state.home.staffMyRequest.approve_status
      },
      set(newValue) {
        this.$store.commit('home/staffMyRequest/SET_APPROVE_STATUS', newValue)
      }
    },
    columns() {
      return [
        { name: this.$t('homePage.requestId') },
        { name: this.$t('homePage.requestDate'), style: 'text-align: center;' },
        { name: this.$t('homePage.className') },
        { name: this.$t('homePage.subjectName') },
        { name: this.$t('homePage.status'), style: 'text-align: center' }
      ]
    }
  },
  methods: {
    fetchResource() {
      this.$store
        .dispatch('home/staffMyRequest/fetchResource')
        .then(() => {
          this.fetchData()
        })
    },
    fetchTotal() {
      this.$store
        .dispatch('home/staffMyRequest/fetchTotal')
        .then(response => {
          this.loading = false
          this.homeworkPending = response.homeworkPending
          this.partiallyApproved = response.partiallyApproved
          this.homeworkApproved = response.homeworkApproved
          this.homeworkRejected = response.homeworkRejected
        })
        .catch(() => {
          this.loading = false
        })
    },
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch('home/staffMyRequest/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(() => {
          this.loading = false
        })
    },
    homework(status_id) {
      this.$store.commit(
        'home/staffHomeworkLinkFromHome/SET_APPROVE_STATUS',
        status_id
      )
      this.$store.commit('home/staffHomeworkLinkFromHome/SET_CREATED_BY', true)
      this.$router.push({
        name: 'home-homework'
      })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    app_type_id: debounce(function(app_type_id) {
      this.fetchData({ app_type_id })
    }, 500),
    approve_status: debounce(function(approve_status) {
      this.fetchData({ approve_status })
    }, 500)
  }
}
</script>
